import { ThunkAction } from '@reduxjs/toolkit';
import { ErroriCarrello } from 'features/sport/components/sportTicket/sportTicketSlice';
import { RootState } from 'lib/centralStore';
import { CarrelloActions, TicketErrore } from '../types';
import { getSliceByTipoTicket } from '../utils';

export const updatePuntataSingolaMultipla =
  (puntataInputValue: number): ThunkAction<void, RootState, unknown, CarrelloActions> =>
  async (dispatch, getState) => {
    const tipo = getState().carrello.tipo;
    const { actions } = getSliceByTipoTicket(tipo);
    dispatch(actions.puntataSingolaMultiplaUpdated(puntataInputValue));
    dispatch(
      actions.ticketUpdated({
        puntata: puntataInputValue,
      })
    );
    dispatch(
      actions.erroriRemoved({
        tipoErrore: 'erroriCarrello',
        errore: {
          type: TicketErrore.IncrementoImportoSingolaMultiplaNonCorretto,
        },
      })
    );
    dispatch(actions.isScommettibileToggled(true));
  };

export const showErroriOnImportoUpdated =
  (type: ErroriCarrello, errore: TicketErrore): ThunkAction<void, RootState, unknown, CarrelloActions> =>
  async (dispatch, getState) => {
    const tipo = getState().carrello.tipo;
    const slice = getSliceByTipoTicket(tipo);
    dispatch(slice.actions.erroriAdded({ errore, tipoErrore: type }));
    dispatch(slice.actions.isScommettibileToggled(false));
  };
